"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ListTemplateLibraryEntriesQuery () {
        return ListTemplateLibraryEntriesQuery;
    },
    get TemplateLibraryEntryParams () {
        return TemplateLibraryEntryParams;
    },
    get TemplateLibraryEntryTypeEnum () {
        return TemplateLibraryEntryTypeEnum;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const TemplateLibraryEntryTypeEnum = _zod.z.enum([
    "review_workflow",
    "review_form",
    "survey",
    "pdf_guide"
]);
const ListTemplateLibraryEntriesQuery = _zod.z.object({
    type: TemplateLibraryEntryTypeEnum.optional()
});
const TemplateLibraryEntryParams = _zod.z.object({
    entryId: _utilsisomorphic.transformObjectId
});
